import useMicControl from '@/composables/shared/mic/process/useMicControl';
import useSystemAudioMicControl from '@/composables/shared/mic/process/useSystemAudioMicControl';
import { useNotification } from '@/composables/shared/useNotification';
import { useSocketStore } from '@/stores/socket';
import { useSocketsStore } from '@/stores/sockets';
import { useSystemAudioMicrophoneStore } from '@/stores/systemAudioMicrophone';
import { UseHangUpCommonOptions } from '@/types/composables';
import { isInCapacitorApp } from '@/utils/device';

export function useHangUpCommon({ setBottomBarStatus, emitClose }: UseHangUpCommonOptions) {
  const socketStore = useSocketStore();
  const socketsStore = useSocketsStore();
  const systemAudioMicrophoneStore = useSystemAudioMicrophoneStore();
  const route = useRoute();
  const router = useRouter();

  const mic = useMicControl();
  const systemAudioMic = useSystemAudioMicControl();
  const { alertEndCall } = useNotification();

  const isApp = isInCapacitorApp();
  const isSelfService = computed<boolean>(() => {
    return route.meta.domain === 'SELF_SERVICE';
  });

  const stopMics = async () => {
    await Promise.all([mic.stopMic(), systemAudioMic.stopMic()]);
  };

  const disconnectSocket = () => {
    socketStore.sendMessageDisconnect();
    socketStore.close();

    if (socketsStore.connections.has(systemAudioMicrophoneStore.socketId)) {
      socketsStore.sendMessageDisconnect(systemAudioMicrophoneStore.socketId);
      socketsStore.close(systemAudioMicrophoneStore.socketId, true);
    }
  };

  const navigateAfterHangUp = () => {
    if (isApp) {
      router.back();
      return;
    }
    if (isSelfService.value) {
      router.replace({ query: {} });
    }
  };

  const handleHangUp = async () => {
    try {
      await stopMics();
      setBottomBarStatus(2);
      emitClose?.();
      navigateAfterHangUp();
    } catch (error) {
      console.error('Error during hang up process:', error);
    } finally {
      disconnectSocket();
    }
  };

  const confirmHangUp = () => {
    alertEndCall(handleHangUp);
  };

  return {
    confirmHangUp,
    handleHangUp,
  };
}
